module.exports = __webpack_public_path__ + "img/pic5.048b61b8.png";